/* =============================================================================
   LOOMA — PDP controllers (spec §8)
   <looma-product-form> variant select + AJAX add + morph
   <looma-accordion>    animated max-height (one open at a time)
   <looma-gallery>      thumbnail swap
   + sticky mobile add. No-JS safe (form POSTs to /cart/add).
   ========================================================================== */
(function () {
  'use strict';
  function cartAdd(fd) {
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST', headers: { Accept: 'application/javascript' }, body: fd
    }).then(function (r) { return r.json(); });
  }
  function afterAdd() {
    fetch('?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (d) {
      var el = document.getElementById('cart-icon-bubble'); if (el && d['cart-icon-bubble']) {
        var doc = new DOMParser().parseFromString(d['cart-icon-bubble'], 'text/html');
        el.innerHTML = (doc.querySelector('#cart-icon-bubble') || doc.body).innerHTML;
      }
    }).catch(function () {});
    window.Looma && window.Looma.emit('looma:cart:updated', {});
    var dr = document.querySelector('looma-cart-drawer');
    if (dr && dr.open) { dr.refresh ? dr.refresh().then(function () { dr.open(); }) : dr.open(); }
  }

  if (!customElements.get('looma-product-form')) {
    customElements.define('looma-product-form', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.idInput = this.querySelector('[name="id"]');
        this.addBtn = this.querySelector('[data-add]');
        this.priceEl = document.querySelector('[data-pdp-price]');
        try { this.variants = JSON.parse(this.querySelector('[data-variants]').textContent); } catch (e) { this.variants = []; }
        this.querySelectorAll('[data-opt]').forEach((b) => b.addEventListener('click', this.onOpt.bind(this)));
        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
      onOpt(e) {
        var btn = e.currentTarget, gi = btn.dataset.optIndex;
        this.querySelectorAll('[data-opt][data-opt-index="' + gi + '"]').forEach((b) => { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
        var lbl = this.querySelector('[data-selected-for="' + gi + '"]'); if (lbl) lbl.textContent = btn.value;
        var sel = [];
        this.querySelectorAll('.is-active[data-opt]').forEach((b) => { sel[+b.dataset.optIndex] = b.value; });
        var m = this.variants.find((v) => v.options.every((o, i) => o === sel[i]));
        if (!m) return;
        if (this.idInput) this.idInput.value = m.id;
        if (this.priceEl && m.price_html) this.priceEl.querySelector('.now') && (this.priceEl.querySelector('.now').textContent = m.price_html);
        var u = new URL(location); u.searchParams.set('variant', m.id); history.replaceState({}, '', u);
        if (this.addBtn) {
          var L = this.addBtn.querySelector('.pdp__add-label');
          if (m.available) { this.addBtn.removeAttribute('disabled'); if (L) L.textContent = this.addBtn.dataset.labelAdd; }
          else { this.addBtn.setAttribute('disabled', ''); if (L) L.textContent = this.addBtn.dataset.labelSold; }
        }
        if (m.featured_media_id) { var g = document.querySelector('looma-gallery'); if (g && g.show) g.show(m.featured_media_id); }
        document.querySelectorAll('[data-sticky-price]').forEach((el) => { if (m.price_html) el.textContent = m.price_html; });
      }
      onSubmit(e) {
        if (!window.fetch) return;
        e.preventDefault();
        if (this.addBtn && this.addBtn.hasAttribute('disabled')) return;
        var self = this;
        cartAdd(new FormData(this.form)).then(function (res) {
          if (res && res.status) { var b = self.querySelector('[data-form-error]'); if (b) { b.textContent = res.description || res.message; b.hidden = false; } return; }
          if (self.addBtn) { self.addBtn.classList.add('is-added'); var L = self.addBtn.querySelector('.pdp__add-label'); var o = L ? L.textContent : ''; if (L) L.textContent = '✓'; setTimeout(function () { self.addBtn.classList.remove('is-added'); if (L) L.textContent = o; }, 1400); }
          afterAdd();
        }).catch(function () { self.form.submit(); });
      }
    });
  }

  if (!customElements.get('looma-accordion')) {
    customElements.define('looma-accordion', class extends HTMLElement {
      connectedCallback() {
        var trigs = [].slice.call(this.querySelectorAll('.accordion__trig'));
        var self = this;
        trigs.forEach(function (t) {
          var p = t.nextElementSibling;
          if (t.getAttribute('aria-expanded') === 'true') p.style.maxHeight = p.scrollHeight + 'px';
          t.addEventListener('click', function () {
            var open = t.getAttribute('aria-expanded') === 'true';
            trigs.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); o.nextElementSibling.style.maxHeight = '0px'; });
            if (!open) { t.setAttribute('aria-expanded', 'true'); p.style.maxHeight = p.scrollHeight + 'px'; }
          });
        });
      }
    });
  }

  if (!customElements.get('looma-gallery')) {
    customElements.define('looma-gallery', class extends HTMLElement {
      connectedCallback() {
        this.slides = this.querySelectorAll('.pdp__media-slide');
        this.thumbs = this.querySelectorAll('.pdp__thumb');
        if (this.querySelectorAll('.pdp__media-slide').length > 4) this.classList.add('pdp__gallery--strip');
        var self = this;
        this.thumbs.forEach(function (t) { t.addEventListener('click', function () { self.show(t.dataset.mediaId); }); });
      }
      show(id) {
        id = String(id);
        this.slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === id); });
        this.thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === id); });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('.pdp__sticky'), anchor = document.querySelector('[data-add]');
    if (bar && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { bar.classList.toggle('is-visible', !en[0].isIntersecting); }, { rootMargin: '0px 0px -120px 0px' });
      io.observe(anchor);
      var s = bar.querySelector('.btn'); if (s) s.addEventListener('click', function () { anchor.click(); });
    }
  });
})();
